// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/exit.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

p {
  font-size: 1rem;
}
@media (min-width: 768px) {
  p {
    font-size: 2rem;
  }
}

h2 {
  font-size: 1.5rem;
}
@media (min-width: 768px) {
  h2 {
    font-size: 3rem;
  }
}

h3 {
  font-size: 1.25rem;
}
@media (min-width: 768px) {
  h3 {
    font-size: 2rem;
  }
}

.panel {
  background-color: rgb(181, 136, 99);
  border-radius: 2rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  width: 65vw;
  height: 70vh;
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 20;
  padding: 1rem;
}
@media (min-width: 768px) {
  .panel {
    width: 40vw;
  }
}
.panel__exit {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: cover;
  border: none;
  background-color: rgba(255, 255, 255, 0);
  outline: none;
  width: 20px;
  height: 20px;
  position: absolute;
  right: 1rem;
}

.panel--animation {
  animation: slidein 0.5s ease-out 0s 1 normal none;
}

@keyframes slidein {
  from {
    transform: translateX(60vw);
  }
  to {
    transform: translateX(0);
  }
}
.settingsform {
  display: flex;
  flex-direction: column;
  height: 90%;
}
.settingsform__submit {
  background-color: rgb(240, 217, 181);
  color: black;
  outline: none;
  border: none;
  padding: 0.5rem;
  border-radius: 12px;
  margin-top: auto;
}
@media (min-width: 768px) {
  .settingsform__submit {
    font-size: 1.5rem;
  }
}
.settingsform__header {
  margin: 0;
  align-self: center;
}
.settingsform__label {
  margin: 0 0 1rem 0;
}
.settingsform__label--radio {
  width: 30%;
}
.settingsform__checkbox {
  margin-bottom: 1rem;
}
@media (min-width: 768px) {
  .settingsform__checkbox {
    width: 1rem;
    height: 1rem;
  }
}
@media (min-width: 768px) {
  .settingsform__radio {
    width: 1rem;
    height: 1rem;
  }
}

@media (min-width: 768px) {
  label {
    font-size: 1.5rem;
  }
}

.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
}

.radiobuttons {
  display: flex;
  flex-direction: row;
}`, "",{"version":3,"sources":["webpack://./src/styles/_partials.scss","webpack://./src/components/SettingsPanel/SettingsPanel.scss"],"names":[],"mappings":"AAiBA;EACE,sBAAA;AChBF;;AD8BA;EACE,qBAAA;AC3BF;;AD6BA;EACE,eAAA;AC1BF;ADJE;EA6BF;IAGI,eAAA;ECxBF;AACF;;AD0BA;EACE,iBAAA;ACvBF;ADbE;EAmCF;IAGI,eAAA;ECrBF;AACF;;ADuBA;EACE,kBAAA;ACpBF;ADtBE;EAyCF;IAGI,eAAA;EClBF;AACF;;AA/BA;EACI,mCDFS;ECGT,mBAAA;EACA,yCAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,aDSY;ACyBhB;ADxCE;ECJF;IAYQ,WAAA;EAoCN;AACF;AAnCI;EACI,yDAAA;EACA,2BAAA;EACA,sBAAA;EACA,YAAA;EACA,wCAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAqCR;;AAlCA;EACI,iDAAA;AAqCJ;;AAnCA;EACI;IACI,2BAAA;EAsCN;EApCE;IACI,wBAAA;EAsCN;AACF;AApCA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AAsCJ;AArCI;EACI,oCD3CM;EC4CN,YAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAuCR;ADpFE;ECsCE;IASQ,iBAAA;EAyCV;AACF;AAvCI;EACI,SAAA;EACA,kBAAA;AAyCR;AAvCI;EACI,kBAAA;AAyCR;AAxCQ;EACI,UAAA;AA0CZ;AAvCI;EACI,mBAAA;AAyCR;ADtGE;EC4DE;IAGQ,WAAA;IACA,YAAA;EA2CV;AACF;AD5GE;ECoEE;IAEI,WAAA;IACA,YAAA;EA0CN;AACF;;ADlHE;EC2EF;IAEQ,iBAAA;EA0CN;AACF;;AAvCA;EACI,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;AA0CJ;;AAxCA;EACI,aAAA;EACA,mBAAA;AA2CJ","sourcesContent":["//Colors\n$square-dark:rgb(181, 136,99);\n$square-light:rgb(240, 217,181);\n$tablet-breakpoint: 768px;\n$desktop-breakpoint: 1280px;\n@mixin tablet {\n  @media (min-width: $tablet-breakpoint) {\n    @content;\n  }\n}\n\n@mixin desktop {\n  @media (min-width: $desktop-breakpoint) {\n    @content;\n  }\n}\n\n*{\n  box-sizing: border-box;\n}\n//Margins for these pages are consistent, so they're defined here as variables.\n$mobile-indent: 1rem;\n$tablet-indent: 2.25rem;\n\n//This needs to change based on the width of the window.\n//We get the width with 100vw, find how much larger the window is than our desktop breakpoint,\n//then divide it by 2 so that the indent can be applied to both sides.\n$base-desktop-indent: 25rem;\n$desktop-indent: calc(\n  $base-desktop-indent + ((1vw * 100) - $desktop-breakpoint) / 2\n);\n\na {\n  text-decoration: none;\n}\np{\n  font-size: 1rem;\n  @include tablet{\n    font-size: 2rem;\n  }\n}\nh2{\n  font-size: 1.5rem;\n  @include tablet{\n    font-size: 3rem;\n  }\n}\nh3{\n  font-size: 1.25rem;\n  @include tablet{\n    font-size: 2rem;\n  }\n}","@use \"../../styles/partials\" as *;\n\n.panel{\n    background-color: $square-dark;\n    border-radius: 2rem;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5 );\n    width: 65vw;\n    height: 70vh;\n    position: fixed;\n    top: 1rem;\n    right: 1rem;\n    z-index: 20;\n    padding: $mobile-indent;\n    @include tablet{\n        width: 40vw;\n    }\n    &__exit{\n        background-image: url('../../assets/exit.svg');\n        background-position: center;\n        background-size: cover;\n        border:none;\n        background-color: rgba(#fff, 0);\n        outline: none;\n        width: 20px;\n        height: 20px;\n        position: absolute;\n        right: 1rem;\n    }\n}\n.panel--animation{\n    animation: slidein 0.5s ease-out 0s 1 normal none;\n}\n@keyframes slidein {\n    from{\n        transform: translateX(60vw);\n    }\n    to{\n        transform: translateX(0)\n    }\n}\n.settingsform{\n    display: flex;\n    flex-direction: column;\n    height:90%;\n    &__submit{\n        background-color: $square-light;\n        color:black;\n        outline:none;\n        border:none;\n        padding: 0.5rem;\n        border-radius: 12px;\n        margin-top: auto;\n        @include tablet{\n            font-size: 1.5rem;\n        }\n    }\n    &__header{\n        margin:0;\n        align-self: center;\n    }\n    &__label{\n        margin:0 0 1rem 0;\n        &--radio{\n            width: 30%;\n        }\n    }\n    &__checkbox{\n        margin-bottom:1rem;\n        @include tablet{\n            width:1rem;\n            height:1rem;\n            }\n    }\n \n    &__radio{\n        @include tablet{\n        width:1rem;\n        height:1rem;\n        }\n    }\n}\nlabel{\n    @include tablet{\n        font-size: 1.5rem;\n    }\n}\n\n.flex-container{\n    display:flex;\n    justify-content: space-between;\n    align-items: baseline;\n    width: 100%;\n}\n.radiobuttons{\n    display: flex;\n    flex-direction: row;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
